// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CustomSlider_wrapper__20q9j","slide":"CustomSlider_slide__2P0pU"};